/**
 * Use this when you want to convert a string to an HTMLImageElement.
 *
 * This is especially useful for converting base64 data (for example: "data:image/png;base64,....") to images in memory.
 */
export const loadImage = (src: string): Promise<HTMLImageElement> => {
  const image = document.createElement('img');
  image.src = src;

  return new Promise((resolve, reject) => {
    image.onload = () => {
      resolve(image);
    };

    image.onerror = (e) => {
      reject(e);
    };
  });
};
